import React from 'react';
import { Path, Rect, Svg } from 'react-native-svg';
import type { SvgProps } from 'react-native-svg';
import { useUnistyles } from 'react-native-unistyles';

import type { AppColors } from '@squire/ui';

interface OpenLockIconProps extends SvgProps {
  size?: number;
  color?: keyof AppColors;
}

const VIEWBOX_WIDTH = 12;
const VIEWBOX_HEIGHT = 12;
const ASPECT_RATIO = VIEWBOX_HEIGHT / VIEWBOX_WIDTH;

const OpenLockIcon: React.FC<OpenLockIconProps> = ({
  size = 16,
  color = 'iconPrimary',
  ...props
}) => {
  const { theme: colors } = useUnistyles();
  return (
    <Svg
      {...props}
      width={size}
      height={size * ASPECT_RATIO}
      viewBox="0 0 12 14"
      fill="none"
    >
      <Path
        d="M3.5 6.5V4.5C3.5 3.119 4.619 2 6 2C7.381 2 8.5 3.119 8.5 4.5V3"
        stroke={colors[color]}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Rect
        x={1.5}
        y={6.5}
        width={9}
        height={6.5}
        rx={1}
        fill={colors[color]}
      />
    </Svg>
  );
};

OpenLockIcon.displayName = 'OpenLockIcon';
export { OpenLockIcon };
